export type DisplayItem = google.payments.api.DisplayItem;
export type DisplayItemType = google.payments.api.DisplayItemType;
export type PaymentAuthorizationResult = google.payments.api.PaymentAuthorizationResult;
export type TransactionInfo = google.payments.api.TransactionInfo;

export const productTypeMap: Record<string, DisplayItemType> = {
  GOODS: "LINE_ITEM",
  DISCOUNT: "DISCOUNT",
  SHIPMENT: "SHIPPING_OPTION",
  HANDLING_FEE: "LINE_ITEM",
};
